import { useParams } from "react-router-dom";
import { TableRowActionLink } from "~components/DataTable/components/TableRowActionLink/TableRowActionLink.tsx";

const ShowRosterFixtureAction = ({ fixtureId }: { fixtureId: string }) => {
  const { customerId, sport, organizationId, seasonId } = useParams();

  return (
    <TableRowActionLink
      to={`/${customerId}/admin/${sport}/${organizationId}/seasons/${seasonId}/fixtures/${fixtureId}/roster`}
      back={`/${customerId}/admin/${sport}/${organizationId}/seasons/${seasonId}/fixtures`}
      icon={<i className="fas fa-users-gear mr-2" />}
      linkLabelIntl={"roster.fixture"}
    />
  );
};

export default ShowRosterFixtureAction;
